import OtherProduct from './OtherProduct.jsx';

export {
  OtherProduct
}


// WEBPACK FOOTER //
// ./components/partials/product/popup-view-detail/other-product/index.js